export enum enumAdsLeadType {
    None = 0,
    FacebookLead = 1,
    PublicLead = 2,
};
